import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomNav.css';

const navItems = [
  { label: '学古诗', path: '/study', icon: '书' },
  { label: '去挑战', path: '/game', icon: '令' },
  { label: '换礼物', path: '/exchange', icon: '宝' },
  { label: '我的', path: '/personal', icon: '我' },
];

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const shouldShow = navItems.some(item => item.path === location.pathname);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <nav
      className={`bottom-nav ${isMobile ? 'bottom-nav--mobile' : 'bottom-nav--desktop'}`}
      aria-label="学生功能导航"
    >
      {navItems.map(item => {
        const active = location.pathname === item.path;
        return (
          <button
            key={item.path}
            type="button"
            className={`bottom-nav-item ${active ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="bottom-nav-icon" aria-hidden="true">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNav;
